import React from "react";
import { Modal, ModalHeader, ModalBody } from "@windmill/react-ui";

const ViewOnTourFeedbackModal = ({ isOpen, onClose, feedbackHistory }) => {
  //  console.log("history data--", feedbackHistory);
  const feedbackList = feedbackHistory || [];

  const getDynamicColor = (name) => {
    let hash = 0;
    for (let i = 0; i < name?.length; i++) {
      hash = name.charCodeAt(i) + (hash << 5) - hash;
    }
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 70%, 40%)`;
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalHeader className="font-semibold text-lg border-b pb-2">
        On-Tour Feedback
      </ModalHeader>

      <ModalBody>
        <div
          //   className="
          //     max-h-50
          //     overflow-y-auto
          //     pr-2
          //     space-y-4
          //     custom-scrollbar
          //   "
          className="border border-gray-300 rounded-md p-3 bg-gray-50 
    max-h-64 overflow-y-auto space-y-3 shadow-inner"
          style={{
            maxHeight: "40vh",
            minHeight: "150px",
            overflowY: "scroll",
            scrollbarWidth: "thin",
          }}
        >
          {feedbackList.length === 0 && (
            <p className="text-sm text-gray-600">
              No feedback history available.
            </p>
          )}

          {feedbackList.map((item, index) => (
            <div
              key={index}
              className="bg-gray-50 p-3 rounded-md shadow-sm border"
            >
              {/* <p className="text-sm font-medium">
                <span className="text-blue-600">
                  {item.employee_name} ({item.employee_profile})
                </span>
                {" : "}
                <span className="text-sm mt-1 text-gray-800 whitespace-pre-wrap">{item.feedback}</span>
                {" "}
                <span className="text-xs text-gray-500 mt-1">{item.updated_at}</span>
              </p> */}
              <p>
                <span
                  className="text-sm font-medium"
                  style={{ color: getDynamicColor(item?.employee_name) }}
                >
                  {item?.employee_name + " (" + item?.employee_profile + ")"}
                </span>
                {" : "}
                <span
                  className="text-sm font-medium"
                  style={{ color: getDynamicColor(item?.employee_name) }}
                >
                  {item?.feedback}
                </span>{" "}
                <span className="text-xs text-gray-500 ml-1">
                  {item.updated_at}
                </span>
              </p>
            </div>
          ))}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ViewOnTourFeedbackModal;
